export default __webpack_public_path__ + "73d2219f6ed7c21293417c53c0ee7d8d.png";